function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "clipboard",
    x: 0.476,
    y: 0.663,
    width: 60,
    height: 60,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.784,15.709l0,26.587c0,4.511 3.669,8.18 8.181,8.18l20.451,0l0,2.045c0,2.26 -1.831,4.091 -4.09,4.091l-26.587,0c-2.26,0 -4.09,-1.831 -4.09,-4.091l0,-32.721c0,-2.26 1.83,-4.091 4.09,-4.091l2.045,0Zm25.564,-10.225c0.542,0 1.062,0.215 1.446,0.599l11.248,11.248c0.385,0.385 0.599,0.904 0.599,1.446l0,23.519c0,2.26 -1.83,4.09 -4.09,4.09l-26.586,0c-2.26,0 -4.091,-1.83 -4.091,-4.09l0,-32.722c0,-2.26 1.831,-4.09 4.091,-4.09l17.383,0Zm9.4,14.316l-10.422,-10.422l0,8.376c0,1.129 0.916,2.046 2.045,2.046l8.377,0Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.fc460fe8.svg";
export { ForwardRef as ReactComponent };